import React from 'react';

export interface CookieIconProps {
  className?: string;
  width?: number;
  height?: number;
  'aria-hidden'?: boolean;
}

export const CookieIcon: React.FC<CookieIconProps> = ({
  className,
  width = 17,
  height = 17,
  'aria-hidden': ariaHidden = true,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    className={className}
  >
    <path d="M6 5.86847C6 6.42075 5.55228 6.86847 5 6.86847C4.44772 6.86847 4 6.42075 4 5.86847C4 5.31618 4.44772 4.86847 5 4.86847C5.55228 4.86847 6 5.31618 6 5.86847Z" />
    <path d="M10 12.8685C10.5523 12.8685 11 12.4208 11 11.8685C11 11.3162 10.5523 10.8685 10 10.8685C9.44771 10.8685 9 11.3162 9 11.8685C9 12.4208 9.44771 12.8685 10 12.8685Z" />
    <path d="M6 10.8685C6 11.4208 5.55228 11.8685 5 11.8685C4.44772 11.8685 4 11.4208 4 10.8685C4 10.3162 4.44772 9.86847 5 9.86847C5.55228 9.86847 6 10.3162 6 10.8685Z" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0127 6.59135C13.0541 6.14154 12.5808 5.56985 12.1291 5.56985C9.90731 5.56985 8.10617 3.77899 8.10617 1.56985C8.10617 1.51105 8.10745 1.45255 8.10997 1.39438C8.14183 0.660432 7.63543 -0.120086 6.91341 0.0154556C2.97724 0.75437 0 4.19147 0 8.31998C0 12.9876 3.80558 16.7715 8.5 16.7715C12.4009 16.7715 15.688 14.1587 16.6879 10.5972C16.7969 10.209 16.4205 9.86848 16.0172 9.86848C14.3509 9.86848 13 8.52534 13 6.86848C13 6.77505 13.0043 6.68261 13.0127 6.59135ZM7.10617 1.56985C7.10617 4.29386 9.29122 6.50063 12.001 6.56825C12.0045 6.57274 12.0076 6.57702 12.0103 6.58099C12.0035 6.6761 12 6.77197 12 6.86848C12 8.92821 13.5606 10.6168 15.5595 10.8428C14.5198 13.7145 11.7528 15.7715 8.5 15.7715C4.35246 15.7715 1 12.4299 1 8.31998C1 4.71249 3.58298 1.69607 7.02035 1.01327C7.04131 1.0437 7.06493 1.08885 7.08322 1.14759C7.10466 1.21642 7.11366 1.28765 7.11091 1.351C7.10776 1.42363 7.10617 1.49659 7.10617 1.56985Z"
    />
  </svg>
);

export default CookieIcon;
